import React, { FC } from "react";

const NotificationSkeleton: FC = () => {
  return (
    <div className="list-dashboard ssc mb-16">
      <div className="ssc-circle" />
      <div className="ssc-head-line w-40" />
    </div>
  );
};

export default NotificationSkeleton;
